import portaro from '../portaro';

portaro.directive('jpPagination', ['TEMPLATES_PATH',
    function(TEMPLATES_PATH) {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: TEMPLATES_PATH + 'jp-pagination.html',
            scope: {
                pagination: '=jpPagination',
                loadingSize: '@?',
                showPageButtons: '=?',
            },
            controller: function($scope) {
                $scope.showPageButtons = $scope.showPageButtons !== false;
                $scope.isPageShowed = function(pageNumber) {
                    var lowestPage = $scope.pagination ? $scope.pagination.getLowestPage() : null;
                    var highestPage = $scope.pagination ? $scope.pagination.getHighestPage() : null;
                    if (lowestPage === null || highestPage === null) {
                        return false;
                    }
                    return lowestPage.pageNumber <= pageNumber && pageNumber <= highestPage.pageNumber;
                }
            }
        };
    }]);